import type { JSX } from "solid-js";

/**
 * The shared right-side drawer shell over the .scrim/.drawer CSS primitive
 * (theme/components/overlays/drawer.css). A panel over the current screen — no
 * route change. The backdrop is a real button so it closes on click and on
 * keyboard, and the aside is a labelled dialog.
 */
export function Drawer(props: {
  title: string;
  onClose: () => void;
  wide?: boolean;
  children: JSX.Element;
}) {
  return (
    <div class="scrim scrim-right">
      <button
        class="scrim-fill"
        type="button"
        aria-label={`Close ${props.title}`}
        onClick={props.onClose}
      />
      <aside
        class={props.wide ? "drawer drawer-wide" : "drawer"}
        role="dialog"
        aria-modal="true"
        aria-label={props.title}
      >
        <div class="drawer-head">
          <span class="drawer-title" style={{ padding: "0" }}>
            {props.title}
          </span>
          <button class="btn" type="button" onClick={props.onClose}>
            Close
          </button>
        </div>
        <div class="drawer-body">{props.children}</div>
      </aside>
    </div>
  );
}
